import { render, staticRenderFns } from "./CreateCommentModalForm.vue?vue&type=template&id=a96a181e&"
import script from "./CreateCommentModalForm.vue?vue&type=script&lang=ts&"
export * from "./CreateCommentModalForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports